package modysy.gamestate

import modysy.{GameController}
import modysy.gamestate.GameState.GameState

/** Holds the current state of the game (e.g. ingame_playing, main_menu ...)
  * State changes are possible by using methods
  * These methods also apply changes necessary for the state change in other classes
  *
  */
class GameStateManager(val controller: GameController) {

  private var _gameState = GameState.mainMenu //temporär
  private var _level: Int = -1 //Später evtl. zu Level-Objekt machen

  def gameState: GameState = _gameState

  def level: Int = _level

  def enterMainMenu(): Unit = {
    if (controller.bgm_player.source != "audio/level_menu.mp3") {
      controller.bgm_player.pauseAudio()
      controller.bgm_player.setAudio("audio/level_menu.mp3")
      controller.bgm_player.setLoop(true)
      controller.bgm_player.playAudio()
    } else if (!controller.bgm_player.playing) {
      controller.bgm_player.playAudio()
    }
  }

  def startLevel(): Unit = {

    //temporäry
    //_level = Some(controller.getLevel)

    /*require(
      (_gameState == GameState.levelMenu || _gameState == GameState.endscreenWin
        || _gameState == GameState.endscreenLose) && _level != -1
    )*/

    _gameState = GameState.ingamePlaying

    controller.bgm_player.pauseAudio()
    controller.sfx_player.setAudio("audio/collision.wav")
    controller.bgm_player.setAudio("audio/agent_move.mp3")
    controller.bgm_player.setLoop(true)

    controller.loadLevel(level)

  }

  def setLevel(lv_nr: Int): Unit = {
    require(
      _gameState != GameState.ingamePlaying && _gameState != GameState.ingamePaused
    )

    _level = lv_nr
  }

  def levelMenu(): Unit = {
    require(_gameState == GameState.mainMenu)

    _gameState = GameState.levelMenu
  }

  def exitGame(): Unit = {
    require(
      _gameState == GameState.ingamePaused
        || _gameState == GameState.endscreenLose
        || _gameState == GameState.endscreenWin
    )

    _gameState = GameState.mainMenu
    enterMainMenu()
    _level = -1
  }

  def backToMainMenu(): Unit = {
    require(_gameState == GameState.levelMenu)
    _gameState = GameState.mainMenu
    enterMainMenu()
  }

  def pauseGame(): Unit = {
    require(_gameState == GameState.ingamePlaying)

    controller.bgm_player.pauseAudio()

    _gameState = GameState.ingamePaused
    controller.uhr.ignoreNext = true

  }

  def resumeGame(): Unit = {
    require(_gameState == GameState.ingamePaused)
    _gameState = GameState.ingamePlaying
  }

  def loseGame(): Unit = {
    require(_gameState == GameState.ingamePlaying)

    _gameState = GameState.endscreenLose

    controller.bgm_player.pauseAudio()
    controller.bgm_player.setAudio("audio/level_failed.mp3")
    controller.bgm_player.setLoop(false)
    controller.bgm_player.playAudio()
  }

  def winGame(): Unit = {
    require(_gameState == GameState.ingamePlaying)

    _gameState = GameState.endscreenWin

    controller.bgm_player.pauseAudio()
    controller.bgm_player.setAudio("audio/level_cleared.mp3")
    controller.bgm_player.setLoop(false)
    controller.bgm_player.playAudio()
  }

  def retryLevel(): Unit = {
    require(
      _gameState == GameState.endscreenLose
        || _gameState == GameState.endscreenWin
        || _gameState == GameState.ingamePaused
    )
    this.startLevel()
  }

  def nextLevel(): Unit = {
    require(
      _gameState == GameState.endscreenWin && _level < controller.numLevels
    )

    this.setLevel(_level + 1)
    this.startLevel()
    _gameState = GameState.ingamePlaying

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/gamestate/GameStateManager.scala